// Shared by Layout (menu badge) and Tag Admin (tab badge + queue): one event so a decision made in the queue updates the
// menu badge without a second fetch.
export const NEEDS_TAGGING_EVENT = 'tec:needs-tagging';

export const needsTaggingLabel = (counts) => {
  if (!counts || !counts.families) return '';
  return `${counts.families} ${counts.families === 1 ? 'family' : 'families'} / ${Number(counts.skus || 0).toLocaleString()} SKUs need tagging`;
};

export const publishNeedsTagging = (counts) => {
  try {
    window.dispatchEvent(new CustomEvent(NEEDS_TAGGING_EVENT, { detail: counts || null }));
  } catch (e) { /* non-browser env */ }
};

export const CONFIDENCE_COLOR = { high: 'success', medium: 'info', low: 'warning', none: 'default' };
